import React from 'react';
import './Outlet.scss';

function Outlet() {
  return (
    <div className="od-home__outlet">
      <div className="od-home__outlet-container">
        <div className="od-home__outlet-content">
          <p className="od-home__outlet-subheading">
            Save up to <strong>50%</strong> on trendy eyewear!
          </p>
          <p className="od-home__outlet-heading">
            <strong>OUTLET</strong>
            <span>
              <span>Limited</span>
              <span>Stock</span>
            </span>
          </p>
        </div>
        <div className="od-home__outlet-action">
          <a className="owndays-btn owndays-btn--secondary" href="/sg/en/campaign/outlet.html">
            SHOP NOW
          </a>
        </div>
      </div>
    </div>
  );
}

export default Outlet;
